import {formMessageError} from "../message/formMessage";

export function checkPasswordConfirmValid(){
    let password = document.getElementById("password"),
        confirm_password = document.getElementById("confirm_password");
    if(password.value != confirm_password.value) {
        confirm_password.setCustomValidity(formMessageError.password.confirm_password);
    } else {
        confirm_password.setCustomValidity('');
    }
}

export function checkPasswordValid() {
    if (this.value == '') {
        this.setCustomValidity(formMessageError.password.empty);
    }
    else if(this.validity.tooShort){
        this.setCustomValidity(formMessageError.password.minlength);
    }
    else {
        this.setCustomValidity('');
    }
    return true;
}
